module.exports = __webpack_public_path__ + "static/media/img-slide3.2ea8714e.jpg";